if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!recommendationsHTML) return;
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();
          this.initForm();

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);

        });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
          nextEl: ".swiper-button--next",
          prevEl: ".swiper-button--prev"
        },
      });
    }

      /**
       * Add to Cart Form
       */
      initForm() {
          /** Variables */
          this.cart =
              document.querySelector("cart-notification") ||
              document.querySelector("cart-drawer");
          this.addToCartForms = this.querySelectorAll(
              "form.upsell__add-to-cart--form"
          );
          if (this.addToCartForms.length) {
              this.addToCartForms.forEach(form => {
                  form.removeAttribute("method");
                  form.removeAttribute("action");
              })
          }
          this.submitButton = this.querySelector('button[type="submit"]');
          /** Event Listeners */
          if (this.addToCartForms) {
              this.addToCartForms.forEach(form => {
                  form.addEventListener(
                      "submit",
                      this.submitAddToCartForm.bind(this)
                  )
              })
          }
      }

      submitAddToCartForm(event) {
          event.preventDefault();

          event.submitter.setAttribute("disabled", "");
          event.submitter.classList.add("add-to-cart--is-disabled");

          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData(event.target);
          if (this.cart) {
              formData.append(
                  "sections",
                  this.cart
                      .getSectionsToRender()
                      .map(section => section.section)
              );
              formData.append("sections_url", window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
              .then(response => response.json())
              .then(response => {
                  if (response.errors) {
                      this.handleErrorMessage(response.errors);
                      return;
                  }

                  if (this.cart) {
                      this.cart.renderContents(response);
                  }

                  updateCartCounters();
              })
              .catch((error) => { console.error(error) })
              .finally(() => {
                  event.submitter.removeAttribute("disabled");
                  event.submitter.classList.remove(
                      "add-to-cart--is-disabled"
                  );

                  const quickCartDrawer = this.closest("quick-cart-drawer");
                  if (quickCartDrawer) {
                      quickCartDrawer.close();
                  }
              });
      }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
